<template>
	<div class="layout-inner pg_content_container course_about my_prog_status" style="padding-top: 0;">
		<navbar></navbar>
    <div class="layout-container">
      <div class="layout-content">
        <div class="page_content_container">
      		<div class="pg_content">
      			<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">
    					<div class="row pg_sec">
          			<div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 sub_hd_bar">
									<!--
									<div class="sub_hd_ic">
									</div>
									-->
            			<div class="hd_txt" style="padding-left: 15px;">My Progress</div>
            		</div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                  <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" v-if="!transactionValidity.transactionValid && !userObj.suspended">
											<div class="row alert_msg_sec">
                      	<div class="col-12 msg_container" v-html="transactionValidity.institutionPurchaseExpirationMessage"></div>
                      	<div class="col-12 btn_container">
													<b-btn class="btn btn-secondary" @click="navigateToSelectedProgram()">Renew</b-btn>
												</div>
                    	</div>
											</div>
										</div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12" v-if="transactionValidity.transactionValid && userObj.suspended">
                      <div class="row alert_msg_sec">
                        <div class="col-12 msg_container" >
                              <span v-html="institution.userSuspensionMessage">
                              </span>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>

										<div class="row progress_details_row">
	                    <div class="col-5">
												<div class="progress_status">
		                      <div class="progress_block float-left">
		                        <div class="state" :class="statusClass(score, programGuide.hideScoreForStudent)">
		                          <span v-if="isScoreNotAvailable || programGuide.hideScoreForStudent" class="progress_val ace_sec_txt" style="font-size: 15px;">N/A</span>
		                          <span v-else class="progress_val ace_sec_txt">{{score}}%</span>
		                        </div>
		                      </div>
													<div class="label">Score</div>
												</div>
	                    </div>
	                    <div class="col-7">
                        <div class="progress-row" v-if="showCourseProgress()">
                          <div class="progress-bar-label ace_sec_txt" :aria-label="inprogressCourses + ' of ' + totalCourses + ' courses'"></div>
                          <b-progress :max="totalCourses">
                            <b-progress-bar :value="completedCourses" :title="showBarTitle(completedCourses, 'completed')" class="prog_bar__completed" v-b-tooltip.hover>{{completedCourses}}</b-progress-bar>
                            <b-progress-bar :value="inprogressCourses" :title="showBarTitle(inprogressCourses, 'in-progress')" class="prog_bar__in_progress" v-b-tooltip.hover>{{inprogressCourses}}</b-progress-bar>
                            <b-progress-bar :value="notStartedCourses" :title="showBarTitle(notStartedCourses, 'not started')" class="prog_bar__not_started" v-b-tooltip.hover>{{notStartedCourses}}</b-progress-bar>
                          </b-progress>
                        </div>
	                      <div class="progress-row" v-else>
	                        <div class="progress-bar-label" style="text-align: center;"
													:title="childrenCompleteCount + ' of ' + childrenCount" v-b-tooltip.hover>
														{{childrenCompleteCount}} of {{childrenCount}}
													</div>
	                        <b-progress :max="childrenCount">
	                          <b-progress-bar :value="childrenCompleteCount" class="prog_bar__completed"></b-progress-bar>
	                        </b-progress>
	                      </div>
	                    </div>
                  	</div>
                </div>

                <program-guide-course-structure  :courseStructure="courses" :parentCategory="parentCategory" firstCategory="true" :programGuide="programGuide" :transactionValidity="transactionValidity" v-if="!userObj.suspended"> </program-guide-course-structure>
    		      </div>
            </div>

            <template v-if="clickedCourse">
              <b-popover ref="courseStatusPopover" :target="'courseStatusSetting-' + clickedCourse.originUuid" triggers="click" :container="'courseStatusPopup-' + clickedCourse.originUuid" placement="auto">
                <div>
                  <b-form-group>
                    <b-form-radio-group plain stacked v-model="selectedStatus">
                      <template v-for="status in [0, 1, 2, 7]">
                        <b-form-radio class="mt-3" :value="status" @change="closeStatusDropDown(true, status)">
                          <b-button :class="courseStatusBackgroundMap[status]" style="width: 170px; font-size: 14px; font-weight: 400; text-align: center;" @click="closeStatusDropDown(true, status)">
                            <div style="color: #fff;">{{courseStatusMap[status]}}</div>
                          </b-button>
                        </b-form-radio>
                      </template>
                    </b-form-radio-group>
                  </b-form-group>
                </div>
              </b-popover>
            </template>
          </div>
    		</div>

        <program-footer-navbar :pageTitle="'My Progress'" :returnTo="returnToPage" :params="{cipCode: cipCode, programGuideCode: programGuideCode, type: type}"></program-footer-navbar>

      </div>
    </div>
	</div>
</template>


<script>
  import _ from 'lodash'
  import { mapState, mapActions } from 'vuex'
  import Navbar from '../../misc/components/./Navbar'
  import ProgramFooterNavbar from '../../misc/components/./ProgramFooterNavbar'
  import ProgramCourseScoreAndProgressBar from './ProgramCourseScoreAndProgressBar'
  import ProgramGuideCourseStructure from './ProgramGuideCourseStructure'
  import { PACKAGE } from '../../../package_constants'

  export default {
    name: 'program-guide-my-program-status',
    props: ['cipCode', 'programGuideCode', 'type', 'returnTo'],
    components: {
      Navbar,
      ProgramFooterNavbar,
      ProgramCourseScoreAndProgressBar,
      ProgramGuideCourseStructure
    },
    data: () => {
      return {
        courses: [],
        parentCategory : {},
        programGuide: {},
        planningStream: {},
        DEFAULT_TYPE: 'MAJOR',
        DEFAULT_RETURN_TO: 'exploreIntro',
        EXPLORE_RESULTS: 'exploreProgramGuideResults',
        clickedCourse: '',
        selectedStatus: '',
        courseStatusMap: {
          0: 'Not Started',
          1: 'In Progress',
          2: 'Completed',
          7: 'Couldn\'t Complete'
        },
        courseStatusBackgroundMap: {
          0: 'status-not-started',
          1: 'status-in-progress',
          2: 'status-completed',
          7: 'status-not-completed'
        },
        score: 0,
        performance: 0,
        childrenCount: 0,
        childrenCompleteCount: 0,
        totalCourses : 0,
        completedCourses : 0,
        inprogressCourses : 0,
        notStartedCourses : 0,

        progressSummaries: [],
        isScoreNotAvailable: true,
        transactionValidity: {}
      }
    },
    beforeMount () {
      this.populateStreamStructure()
    },
    mounted () {
      this.loadDataForProgramGuideMyStatus()
    },
    methods: {
      ...mapActions([
        'loadProgramGuide',
        'loadStreamWithStructure',
        'updateProgramCourseStatus',
        'loadCheckTransactionValidity',
        'loadStreamWithStructureSummary'
      ]),
      async loadDataForProgramGuideMyStatus () {
        let cipCode = this.cipCode
        let programGuideCode = this.programGuideCode
        let returnTo = this.returnTo && this.returnTo.length ? this.returnTo : this.DEFAULT_RETURN_TO
        if (!cipCode || !programGuideCode) {
          return this.$router.push({ name: returnTo })
        }
        this.programGuide = await this.loadProgramGuide({
          cipCode: cipCode,
          programGuideCode: programGuideCode,
          type: this.programGuideType,
          loadDataFromServer: true
        })
        if (!this.programGuide || !this.programGuide.cipCode) {
          return this.$router.push({ name: returnTo })
        }
        this.transactionValidity = await this.loadCheckTransactionValidity(programGuideCode)
      },
      navigateToSelectedProgram (data) {
        let routerParams = {
          cipCode: this.cipCode,
          programGuideCode: this.programGuideCode,
          type: this.type,
          showBackToResultButton: true
        }
        return this.$router.push({name: 'programGuideMenu', params: routerParams})
      },
      resetData () {
        this.score = 0
        this.performance = 0
        this.childrenCount = 0
        this.childrenCompleteCount = 0
        this.totalCourses = 0
        this.completedCourses = 0
        this.inprogressCourses = 0
        this.notStartedCourses = 0
        this.courses = []
        this.parentCategory = {}
        this.programGuide = {}
        this.planningStream = {}
        this.progressSummaries = [],
        this.isScoreNotAvailable = true
      },
      async populateStreamStructure () {
        this.resetData()
        this.planningStream = await this.loadStreamWithStructure(this.programGuideCode)
        let structure = this.planningStream.structure
        if (structure) {
          let children = JSON.parse(structure)
          if (children.length > 0 && children.length <2) {
            let childStructure = children[0].structure
            this.parentCategory = children[0]
            if (childStructure) {
              let structure = JSON.parse(childStructure)
              this.courses = _.sortBy(structure, 'order')
            }
          }else{
            this.parentCategory = this.planningStream
            let structure1 = JSON.parse(structure)
            this.courses = _.sortBy(structure1, 'order')
          }
        }
        let summaries = await this.loadStreamWithStructureSummary(this.programGuideCode)
          for (let i = 0; i < summaries.length; i++) {
            let competencySummary =  summaries[i]
            competencySummary.uuid = this.programGuideCode + '_' + competencySummary.uuid
            this.childrenCount += competencySummary.childrenCount
            this.childrenCompleteCount+= competencySummary.childrenCompleteCount
            if (competencySummary.performance) {
                  console.log('competencySummary.performance '+competencySummary.performance)
                  this.isScoreNotAvailable = false
                  this.performance += competencySummary.performance
                  this.progressSummaries.push(competencySummary)
            }
            if(competencySummary.status==1){
              this.inprogressCourses +=1
            }
            if(competencySummary.status==2){
              this.completedCourses +=1
            }

        }
        let catalogAndCourses = this.getTotalCourseCatalogs(this.courses)
        this.totalCourses = catalogAndCourses.length
        this.notStartedCourses = (this.totalCourses - (this.inprogressCourses+this.completedCourses))
        this.score = (this.performance / this.progressSummaries.length).toFixed(2)
      },
      getTotalCourseCatalogs(entities) {
        let courses = []

        entities.forEach((item, i) => {
           if (item.entityType === 'folder') {
             if (item.structure) {
               let structure = JSON.parse(item.structure)
               if (structure) {
                 let recursionEntities = _.sortBy(structure, 'order')
                 let response = []
                 response = this.getTotalCourseCatalogs(recursionEntities)
                 courses.push(...response)
               }
             }
           } else {
             courses.push(item)
           }

        })

        return courses
      },
      showCourseProgress () {
        let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
        if (programDetail) {
          let flags = programDetail.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCourseProgress') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      returnToClicked () {
        return this.$router.push({ name: this.returnTo })
      },
      deCamelCase () {
        if (!this.returnTo) {
          this.returnTo = this.DEFAULT_RETURN_TO
        }
        if (this.returnTo === this.EXPLORE_RESULTS) {
          return 'return to program results'
        }
        let result = this.returnTo.replace(/([A-Z])/g, ' $1')
        return 'return to ' + result
      },
      setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
      setThumbnailTitle (course) {
        if ((course.title.indexOf('-') !== -1) && (course.title.indexOf('-') < 7)) {
          let splitted = course.title.split('-')
          if (splitted.length > 0) {
            return splitted[0]
          }
        }
        return course.title.substring(0, 7)
      },
      async updateCourseStatus (streamId, status) {
        let data = {
          uuid: streamId,
          status: status
        }
        this.updateProgramCourseStatus(data).then(result => {
          this.populateStreamStructure()
        })
      },
      openStatusDropDown (course) {
        this.selectedStatus = course.courseStatus
        if (this.clickedCourse) {
          this.closeStatusDropDown(false)
        } else {
          this.clickedCourse = course
          setTimeout(() => {
            this.$refs.courseStatusPopover.$emit('open')
          }, 250)
        }
      },
      closeStatusDropDown (toBeUpdated, status) {
        if (toBeUpdated) {
          this.updateCourseStatus(this.clickedCourse.uuid, status)
        }
        this.clickedCourse = ''
        this.selectedStatus = ''
        this.$refs.courseStatusPopover.$emit('close')
      },
      navigateToCourseDashboard (course) {
        if (course.entityType === 'deliverycontext') {
          this.$store.commit('LOAD_COURSE', {})
          this.$store.commit('LOAD_CLASS_SUMMARY', {})
          this.$store.commit('LOAD_COURSE_TOPICS', {})
          this.$store.commit('LOAD_COURSE_LINEAR_TOPICS', {})
          let courseId = course.originUuid
          return this.$router.push({name: 'courseDashboard', params: {uuid: courseId}})
        }
      },
      aggregateProgressSummary (progressSummary) {
        if ((progressSummary.status === 1) || (progressSummary.status === 2)) {
          this.isScoreNotAvailable = false
          this.progressSummaries.push(progressSummary)
          this.performance += progressSummary.performance
        }
        this.childrenCount += progressSummary.childrenCount
        this.childrenCompleteCount += progressSummary.childrenCompleteCount
        setTimeout(() => {
          this.score = (this.performance / this.progressSummaries.length).toFixed(1)
        }, 1000)
      },
      showMoreDescLnk (id) {
				let entityDescHeight = $('#entityDesc_' + id + ' desc_txt').height()
				if (entityDescHeight > 45) {
          return 'hide_more_link'
        } else {
          return 'show_more_link'
        }
      },
      showMoreDescLink (desc) {
        if(desc){
          desc = desc.replace( /(<([^>]+)>)/ig, '');
        }
        if (desc && desc.length > 101) {
          return true
        } else {
          return false
        }
      },
      showDesc (fullDesc){
        if(fullDesc){
          let desc = fullDesc.replace( /(<([^>]+)>)/ig, '');
          if(desc.length>101){
            return desc.substring(0,101) + '...'
          }
          return desc;
        }
        return fullDesc
      },

      statusClass (score, hideScore) {
        if (score && !this.isScoreNotAvailable && !hideScore) {
          if (score >= 90) {
            return 'gradeA'
          } else if (score >= 80 && score < 90) {
            return 'gradeB'
          } else if (score >= 65 && score < 80) {
            return 'gradeC'
          } else if (score >= 40 && score < 65) {
            return 'gradeD'
          } else if (score < 40) {
            return 'gradeE'
          }
        } else {
          return 'noGrade'
        }
      },
			showBarTitle (count, status) {
        if (count > 1) {
          return count + ' courses are ' + status
        } else {
          return count + ' course is ' + status
        }
      }
    },
    computed: {
      ...mapState({
        'enabledFeatures': state => state.dashboard.enabledFeatures,
        'institution': state => state.dashboard.institution,
        'packages': state => state.dashboard.packages,
        'userObj': state => state.login.userObj

      }),
      programGuideType () {
        let programGuideType = this.type
        if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
          programGuideType = this.DEFAULT_TYPE
        }
        return programGuideType
      },
      returnToPage () {
        return this.returnTo || 'programGuideMenu'
      }
    }
  }
</script>

<style>
  div[id^="courseStatusPopup-"] .popover .arrow {
    display: none !important;
  }
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideMyProgramStatus.vue